import regularCampiagnIcon from "assets/images/regular-campaign.svg";
import sequentialCampiagnIcon from "assets/images/sequential-campaign.svg";
import abCampiagnIcon from "assets/images/ab-campaign.svg";
import socialCampiagnIcon from "assets/images/social-campaign.svg";
import viewpaths from "global/constants/ViewPathConstants";
import { hasAccessTo } from "layouts/Config";
import strings from "global/constants/StringConstants";

export const tabs = () => {
  return [
    {
      label: "Email",
      value: "email",
      key: "email",
      hasPermission: hasAccessTo(strings.campaign, strings.fetchPermission),
      permittedForTrial: true,
    },
    {
      label: "Social",
      value: "social",
      key: "social",
      hasPermission: hasAccessTo(strings.social, strings.fetchPermission),
      permittedForTrial: false,
    },
  ];
};

export const insertRetargetingField = (campaignName: string) => {
  return {
    groupName: {
      value: campaignName ?? "",
      error: "",
    },
    groupType: {
      value: "",
      error: "",
    },
    open: {
      value: false,
      error: "",
    },
    click: {
      value: false,
      error: "",
    },
    notOpened: {
      value: false,
      error: "",
    },
  } as any;
};

export const validateRetargetForm = (userDetail: any) => {
  let errors = userDetail;
  let isValid = true;
  const open = userDetail.open.value;
  const click = userDetail.click.value;
  const notOpened = userDetail.notOpened.value;

  if (!open && !click && !notOpened) {
    errors.open.error = "Please select the audience";
    errors.click.error = "Please select the audience";
    errors.notOpened.error = "Please select the audience";
    isValid = false;
  } else {
    errors.open.error = "";
    errors.click.error = "";
    errors.notOpened.error = "";
  }

  return { isValid, errors };
};

export const metricLabels: { [key: number]: string } = {
  1: "Requested",
  2: "Sent",
  3: "Success",
  4: "Failed",
  5: "Opened",
  6: "Clicked",
  7: "Unsubscribed",
  8: "Delivered",
  9: "Soft Bounced",
  10: "Hard Bounced",
  11: "HARDBOUNCE",
  12: "Bounced",
};

export const SocialListWithPagination = [
  // Example campaigns (You can add more to test pagination)
  {
    title: "New Year Campaign",
    status: "Draft",
    createdBy: "Albin Musk (albinmusk@gmail.com)",
    schedule: "3rd Jan, 2025",
    type: ["facebook"],
  },
  {
    title: "New Year Campaign",
    status: "Completed",
    createdBy: "Albin Musk (albinmusk@gmail.com)",
    schedule: "3rd Jan, 2025",
    type: ["instagram"],
  },
  {
    title: "New Year Campaign",
    status: "Completed",
    createdBy: "Albin Musk (albinmusk@gmail.com)",
    schedule: "3rd Jan, 2025",
    type: ["facebook", "instagram"],
  },
  {
    title: "New Year Campaign",
    status: "Submitted",
    createdBy: "Albin Musk (albinmusk@gmail.com)",
    schedule: "3rd Jan, 2025",
    type: ["instagram"],
  },
  // Add more items as needed
];
export const CampaignOptions = [
  {
    label: "All Campaigns",
    value: "all",
  },
  {
    label: "My Campaigns",
    value: "my",
  },
  {
    label: "Team's Campaigns",
    value: "team",
  },
];

export const getCampaignStatusOptions = (campaignType: string) => {
  const baseOptions = [
    { label: "All status", value: "All" },
    { label: "Draft", value: "Draft" },
    { label: "Submitted", value: "Submitted" },
    { label: "Completed", value: "Completed" },
    { label: "Failed", value: "Failed" },
    { label: "A/B test waiting", value: "ABTestWaiting" },
    { label: "In Review", value: "InReview" },
    { label: "Rejected", value: "Rejected" },
  ];

  if (campaignType === "Regular") {
    return baseOptions.filter((option) => option.value !== "ABTestWaiting");
  }

  return baseOptions;
};

export const CampaignTypeOptions = [
  {
    label: "All type",
    value: "all",
  },
  {
    label: "Regular campaigns",
    value: "Regular",
  },
  {
    label: "A/B test campaigns",
    value: "ABTesting",
  },
];

export const socialCampaignStatusOptions = [
  {
    label: "All status",
    value: "All",
  },
  {
    label: "Submitted",
    value: "Submitted",
  },
  {
    label: "Completed",
    value: "Completed",
  },
  {
    label: "Failed",
    value: "Failed",
  },
];

export const campaignTypes = () => {
  return [
    {
      icon: regularCampiagnIcon,
      title: "Regular Campaign",
      desc: "Engage your audience with regular campaigns that keep them informed and interested. Perfect for maintaining a steady connection and delivering consistent updates.",
      link: viewpaths.createRegularCampaignViewPath,
      isUserPermitted: hasAccessTo(strings.campaign, strings.addPermission),
      permittedForTrial: true,
    },
    {
      icon: sequentialCampiagnIcon,
      title: "Sequential Campaign",
      desc: "Create a series of campaigns all at once. It's ideal for setting up a planned communication flow, ensuring your message unfolds seamlessly over time.",
      link: viewpaths.createSequentialCampaignViewPath,
      isUserPermitted: hasAccessTo(strings.campaign, strings.addPermission),
      permittedForTrial: true,
    },
    {
      icon: abCampiagnIcon,
      title: "AB Campaign",
      desc: "Optimize your campaigns with AB testing. Test different variables and send the winning version to the rest of your audience, ensuring maximum impact and engagement.",
      link: viewpaths.createABTestCampaignViewPath,
      isUserPermitted: hasAccessTo(strings.campaign, strings.addPermission),
      permittedForTrial: false,
    },
    {
      icon: socialCampiagnIcon,
      title: "Social Campaign",
      desc: "Schedule or post your content directly to social media platforms. Streamline your social media marketing and keep your audience engaged across channels",
      link: viewpaths.createSocialCampaignViewPath,
      isUserPermitted:
        hasAccessTo(strings.campaign, strings.addPermission) &&
        hasAccessTo(strings.social, strings.addPermission),
      permittedForTrial: false,
    },
  ];
};

export const MoreActionsMenu = (moreOptions: {
  type: string;
  status: string;
}) => {
  const inReview = moreOptions.status === "InReview";
  const submitted =
    moreOptions.type !== "ABTesting" &&
    (moreOptions.status === "Submitted" || moreOptions.status === "Draft")
      ? true
      : false;

  const isAbTestSubmitted =
    moreOptions.type === "ABTesting" && moreOptions.status === "Submitted"
      ? true
      : false;
  const isAbTestDraft =
    moreOptions.type === "ABTesting" && moreOptions.status === "Draft"
      ? true
      : false;
  let menuItems;
  if (submitted) {
    menuItems = [
      {
        label: "Edit",
        value: "edit",
      },
      {
        label: "Rename",
        value: "rename",
      },
      {
        label: "Delete",
        value: "delete",
      },
    ];
  } else if (isAbTestSubmitted) {
    menuItems = [
      {
        label: "View",
        value: "view",
      },
      {
        label: "Rename",
        value: "rename",
      },
    ];
  } else if (inReview) {
    menuItems = [
      {
        label: "Rename",
        value: "rename",
      },
    ];
  } else if (isAbTestDraft) {
    menuItems = [
      {
        label: "Edit",
        value: "edit",
      },
      {
        label: "Rename",
        value: "rename",
      },
      {
        label: "Delete",
        value: "delete",
      },
    ];
  } else {
    menuItems = [
      {
        label: "View",
        value: "view",
      },
      {
        label: "Rename",
        value: "rename",
      },
    ];
  }

  return menuItems;
};

export const campaignOverview = {
  id: 60,
  title: "New Year Campaign",
  status: "Draft",
  createdBy: "Albin Musk (albinmusk@gmail.com)",
  schedule: "3rd Jan, 2025",
  type: "Regular Campaign",
  metrics: [
    { label: "Open rate", value: 89 },
    { label: "Click rate", value: 82 },
    { label: "CTOR", value: 75 },
  ],
  otherMetrics: [
    { label: "Unsubscribe Rate", value: 10 },
    { label: "Hard Bounce", value: 10 },
    { label: "Spam Complaints", value: 10 },
    { label: "Soft Bounce", value: 10 },
  ],
  subject: "",
  actions: [
    {
      campaignName: "Tech expo",
      campaignOwner: "myra@sendwithmailzzy.com",
      contactEmail: "anish@pixsterstudio.com",
      actionDetails: {
        ipAddress: "115.117.175.18",
        urls: [],
        actionTimeLines: ["2025-01-06T02:14:37"],
        userAgent: "Laptop",
      },
      action: "Opened",
    },
    {
      campaignName: "Tech expo",
      campaignOwner: "myra@sendwithmailzzy.com",
      contactEmail: "ankur.sharma@jignect.tech",
      actionDetails: {
        ipAddress: "123.201.108.247",
        urls: [],
        actionTimeLines: ["2025-01-06T00:41:15"],
        userAgent: "Laptop",
      },
      action: "Opened",
    },
    {
      campaignName: "Tech expo",
      campaignOwner: "myra@sendwithmailzzy.com",
      contactEmail: "chidananda.vasudeva@razorpay.com",
      actionDetails: {
        ipAddress: "66.249.87.224",
        urls: [],
        actionTimeLines: ["2025-01-05T23:43:47"],
        userAgent: "Laptop",
      },
      action: "Opened",
    },
    {
      campaignName: "Tech expo",
      campaignOwner: "myra@sendwithmailzzy.com",
      contactEmail: "devarsh.panchal@softsages.com",
      actionDetails: {
        ipAddress: "157.32.40.136",
        urls: [],
        actionTimeLines: ["2025-01-05T23:50:45"],
        userAgent: "Mobile",
      },
      action: "Opened",
    },
    {
      campaignName: "Tech expo",
      campaignOwner: "myra@sendwithmailzzy.com",
      contactEmail: "divyesh@bizcompass.in",
      actionDetails: {
        ipAddress: "104.211.156.139",
        urls: [
          "https://calendly.com/mailzzy?utm_source=email&utm_medium=emailer&utm_campaign=calendly_meeting",
          "https://x.com/Mailzzy_email",
          "https://x.com/Mailzzy_email",
          "https://calendly.com/mailzzy?utm_source=email&utm_medium=emailer&utm_campaign=calendly_meeting",
        ],
        actionTimeLines: [
          "2025-01-05T23:44:48",
          "2025-01-05T23:44:47",
          "2025-01-05T23:44:48",
          "2025-01-05T23:44:47",
          "2025-01-05T23:43:56",
        ],
        userAgent: "Laptop",
        city: "Mumbai",
        country: "IN",
      },
      action: "Clicked",
    },
  ],
};

export const initialCampaignsFilterState = (
  page: number,
  rowsPerPage: number,
  searchText: string,
  ownerDropdownValue?: string,
  statusDropdownValue?: string,
  campaignTypeDropdownValue?: string
) => {
  return {
    page: page,
    rowsPerPage,
    searchText,
    ownerDropdownValue,
    statusDropdownValue,
    campaignTypeDropdownValue,
  };
};

export const variableOptions = {
  subjectLine: {
    label: "Subject Line",
    value: "subjectLine",
  },
  fromName: {
    label: "From Name",
    value: "fromName",
  },
  content: {
    label: "Content / Design",
    value: "content",
  },
  scheduleTime: {
    label: "Schedule Time",
    value: "scheduleTime",
  },
} as {
  [key: string]: {
    label: string;
    value: string;
  };
};

export const MoreActionsInCampaign = (
  type: string,
  status: string,
  hasCampaignAddAccess: boolean
) => {
  let menuItems = [];
  if (hasCampaignAddAccess && type !== "ABTesting" && status !== "InProgress") {
    menuItems.push({
      label: "Resend",
      value: "resend",
    });
    menuItems.push({
      label: "Retarget",
      value: "retarget",
    });
  }
  if (status !== "InProgress") {
    menuItems.push({
      label: "Export Report",
      value: "export-report",
    });
  }
  return menuItems;
};
